/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OutputViewerAnimationLimitLinesCountSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('OUTPUT_VIEWER_ANIMATION_LIMIT_LINES_COUNT'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class OutputViewerAnimationLimitLinesCountSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OutputViewerAnimationLimitLinesCountSettingParser.decode(input).map(res => new OutputViewerAnimationLimitLinesCountSetting(res));
    }
    static unsafeDecode(input) {
        return OutputViewerAnimationLimitLinesCountSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OutputViewerAnimationLimitLinesCountSettingParser.encode(data);
    }
    static schema() {
        return OutputViewerAnimationLimitLinesCountSettingParser.schema();
    }
}
